import React, {useEffect} from 'react';
import {useReport} from "../../../utilities/contexts/report-context";
import HorizontalLabelledField from "../../UI/Fields/HorizontalLabelledField";
import VerticalLabelledField from "../../UI/Fields/VerticalLabelledField";
import {dateToFileName, formatInt, formatPrice, nameToFileName} from "../../../utilities/data/parser";
import PrintButton from "../../UI/PrintButton";
import RowAligned from "../../UI/Structure/RowAligned";
import {CSVLink} from "react-csv";
import CsvButton from "../../UI/CSVButton";

const headers = [
    {label: "Nr Lotto", key: "nrlotto"},
    {label: "Provenienza", key: "buying_article"},
    {label: "Articolo", key: "sales_article"},
    {label: "Cliente", key: "client"},
    {label: "Resa", key: "performance"},
    {label: "Costo Mq", key: "costs_per_mq"},
    {label: "Ve/Mq", key: "sold_per_mq"},
    {label: "Diff %", key: "diff_percentage"},
    {label: "N. Mq Vend.", key: "sold_mq"},
    {label: "Tot costo", key: "total_cost"},
    {label: "Tot Vend", key: "total_profit"},
    {label: "Margine", key: "margin"},
    {label: "Tot Nr. Pz", key: "nrpz"}
];

const SalesTotals = ({onClick}) => {

    const {salesData, salesFormData} = useReport();

    const getCsvFileName = () => {
        let start = dateToFileName(salesFormData.date_from)
        let end = dateToFileName(salesFormData.date_to);
        let client = salesFormData?.client?.name ? nameToFileName(salesFormData.client.name) + "_" : "";
        return `resoconto_vendite_${client}dal_${start}_al_${end}`;
    }

    // format a row for CSV output
    const formatCsvRow = (element) => ({
        ...element,
        performance: formatPrice(element?.performance),
        costs_per_mq: formatPrice(element?.costs_per_mq ?? 0),
        sold_per_mq: formatPrice(element?.sold_per_mq ?? 0),
        diff_percentage: formatPrice(element?.diff_percentage ?? 0),
        sold_mq: formatPrice(element?.sold_mq ?? 0),
        total_cost: formatPrice(element?.total_cost ?? 0),
        total_profit: formatPrice(element?.total_profit ?? 0),
        margin: formatPrice((element?.total_cost ?? 0) - (element?.total_profit ?? 0)),
        nrpz: formatInt(element?.nrpz ?? 0),
    });

    // Build CSV: sold rows, empty row, title row, unsold rows
    const buildCsvData = () => {
        const sold = Array.isArray(salesData?.list) ? salesData.list.map(formatCsvRow) : [];
        const unsold = Array.isArray(salesData?.unsoldList) ? salesData.unsoldList.map(formatCsvRow) : [];

        if (unsold.length === 0) return sold;

        const emptyRow = headers.reduce((acc, h) => { acc[h.key] = ""; return acc; }, {});
        const titleRow = headers.reduce((acc, h, idx) => { acc[h.key] = idx === 0 ? "RESI" : ""; return acc; }, {});
        return [...sold, emptyRow, titleRow, ...unsold];
    }

    return (
        <div className="flex flex-row justify-between gap-2 border-t border-black p-1">
                <RowAligned>
                    <PrintButton onClick={onClick}/>
                    <CSVLink data={buildCsvData()}
                             filename={getCsvFileName()}
                             separator={";"}
                             headers={headers}>
                        <CsvButton/>
                    </CSVLink>
                </RowAligned>

            <div className="flex flex-row items-center gap-4">
                <VerticalLabelledField label="Totali venduto">
                    <div className="flex flex-row gap-2">
                        <HorizontalLabelledField label="Nrpz">
                            {formatInt(salesData.totals?.sold_leathers?.nrpz)}
                        </HorizontalLabelledField>
                        <HorizontalLabelledField label="Costi">
                            {formatPrice(salesData.totals?.sold_leathers?.costs)}€
                        </HorizontalLabelledField>
                        <HorizontalLabelledField label="Vendite">
                            {formatPrice(salesData.totals?.sold_leathers?.sales)}€
                        </HorizontalLabelledField>
                        <HorizontalLabelledField label="Profitti">
                            {formatPrice(salesData.totals?.sold_leathers?.profit)}€
                        </HorizontalLabelledField>
                    </div>
                </VerticalLabelledField>

                {salesData?.totals?.unsold_leathers && (
                    <VerticalLabelledField label="Totali resi">
                        <div className="flex flex-row gap-2">
                            <HorizontalLabelledField label="Nrpz">
                                {formatInt(salesData.totals.unsold_leathers.nrpz)}
                            </HorizontalLabelledField>
                            <HorizontalLabelledField label="Costi">
                                {formatPrice(salesData.totals.unsold_leathers.costs)}€
                            </HorizontalLabelledField>
                            <HorizontalLabelledField label="Vendite">
                                {formatPrice(salesData.totals.unsold_leathers.sales)}€
                            </HorizontalLabelledField>
                            <HorizontalLabelledField label="Profitti">
                                {formatPrice(salesData.totals.unsold_leathers.profit)}€
                            </HorizontalLabelledField>
                        </div>
                    </VerticalLabelledField>
                )}
            </div>
        </div>
    );
};

export default SalesTotals;
